import React from "react";
import "../../styles/components/content.css";

export default function ContentThumbnail({ content }) {
  if (!content) {
    return <div className="content-thumbnail-placeholder">Loading...</div>;
  }

  const url = content.blobUrlAccessible;
  const isPdf =
    (content.contentType && content.contentType.toLowerCase().includes("pdf")) ||
    /\.pdf($|\?)/i.test(url);

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="content-thumbnail"
      title={content.description || "Open content"}
    >
      <div className="content-thumbnail-preview">
        {isPdf ? (
          <>
            {/* Using iframe for a tiny PDF preview.
                pointer-events:none so the anchor remains clickable. */}
            <iframe
              className="content-thumbnail-iframe"
              src={`${url}#toolbar=0&navpanes=0&scrollbar=0&page=1`}
              title={content.description || "PDF preview"}
              loading="lazy"
            />
            <div className="content-thumbnail-fallback">PDF</div>
          </>
        ) : (
          <img
            src={content.thumbnailUrl || url}
            alt={content.description || "Preview"}
            className="content-thumbnail-img"
            loading="lazy"
          />
        )}
      </div>
      {content.description && (
        <div className="content-thumbnail-text">{content.description}</div>
      )}
    </a>
  );
}